import {
    ChangeDetectionStrategy,
    Component,
} from '@angular/core';
import {
    AppStateFacade,
    Setting,
} from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import {
    IAuditChange,
    IAuditLogFull,
} from '@models';
import { TranslateService } from '@ngx-translate/core';
import { isEmptyObject } from '@utils/audit.utils';

import difference from 'lodash-es/difference';
import intersection from 'lodash-es/intersection';
import * as moment from 'moment';

@Component({
    templateUrl: './audit-data.modal.html',
    styleUrls: ['audit-data.modal.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditLogDataModalComponent
    extends UiModalComponent<IAuditLogFull> {
    public isEmptyObject = isEmptyObject;
    public changes: IAuditChange[] = [];
    private _translateService = this._injector.get<TranslateService>(TranslateService);
    private _appState = this._injector.get<AppStateFacade>(AppStateFacade);

    public applyFormatting = (value: any): any => {
        if (
            !!value &&
            !!value.translate
        ) {
            return this._translateService.instant(
                value.translate.key,
                value.translate.data,
            );
        }

        if (value instanceof Date) {
            return this.formatDate(value);
        }

        if (value == null ||
            value === '' ||
            isEmptyObject(value) ||
            value instanceof Array && value.length === 0
        ) {
            return 'N/A';
        }

        if (value instanceof Array) {
            return value.map(this.applyFormatting);
        }

        const keys = Object.keys(value);
        if (
            typeof value === 'object' &&
            keys.length
        ) {
            const o: any = {};
            keys.forEach(k => o[k] = this.applyFormatting(value[k]));
            return o;
        }
        return value;
    }

    public formatDate(date: Date) {
        return moment(date)
            .tz(this._appState.settings.get(Setting.timezone)!)
            .format('L LTS');
    }

    public isArray(obj: any) {
        return obj instanceof Array;
    }

    public difference(arr1: ArrayLike<{}>, arr2: ArrayLike<{}>) {
        const common = intersection(arr1, arr2);
        return difference(arr1, common);
    }
}
